import {
  CalendarIcon,
  SquaresPlusIcon,
  UserCircleIcon,
  UserGroupIcon,
  MapPinIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';
import { Close } from '@mui/icons-material';
import { Card, IconButton, Stack, Theme, Typography, useTheme } from '@mui/material';
import { ReportsGeographyType } from 'src/@types/geographyFilters';

type Props = {
  type: 'user' | 'team' | 'project' | 'date' | ReportsGeographyType | 'outreach';
  value: string;
  onDelete: VoidFunction;
};

export function FilterLabel({ type, value, onDelete }: Props) {
  const theme = useTheme();

  return (
    <Card sx={{ pl: 1, mr: 1, borderColor: 'primary.lighter' }} variant="outlined">
      <Stack direction="row" alignItems="center" spacing={0}>
        {getIcon(type, theme)}
        <Typography paddingLeft={1} paddingRight={0.25} variant="body2">
          {value}
        </Typography>
        <IconButton size="small" onClick={onDelete}>
          <Close fontSize="small" />
        </IconButton>
      </Stack>
    </Card>
  );
}

const getIcon = (
  type: 'user' | 'team' | 'project' | 'date' | ReportsGeographyType | 'outreach',
  theme: Theme
) => {
  switch (type) {
    case 'user':
      return <UserCircleIcon width={18} color={theme.palette.primary.main} />;
    case 'project':
      return <SquaresPlusIcon width={18} color={theme.palette.primary.main} />;
    case 'date':
      return <CalendarIcon width={18} color={theme.palette.primary.main} />;
    case 'team':
      return <UserGroupIcon width={18} color={theme.palette.primary.main} />;
    case 'county_name':
    case 'precinct_name':
    case 'congressional_district':
    case 'state_leg_upper_district':
    case 'state_leg_lower_district':
    case 'dma_name':
      return <MapPinIcon width={18} color={theme.palette.primary.main} />;
    case 'outreach':
      return <ChartBarIcon width={18} color={theme.palette.primary.main} />;
  }
};
